var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
import { Errno, ErrnoError } from '@zenfs/core';
import { deserialize, member, struct, types as t } from 'utilium';
import { Directory } from './Directory.js';
import { rockRidgeIdentifier } from './constants.js';
import { CLEntry, EREntry, NMEntry, RREntry, SLEntry, SPEntry, constructSystemUseEntries } from './entries.js';
import { ShortFormDate } from './utils.js';
let DirectoryRecord = (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _length_decorators;
    let _length_initializers = [];
    let _length_extraInitializers = [];
    let _extendedAttributeRecordLength_decorators;
    let _extendedAttributeRecordLength_initializers = [];
    let _extendedAttributeRecordLength_extraInitializers = [];
    let __lba_decorators;
    let __lba_initializers = [];
    let __lba_extraInitializers = [];
    let __lbaBE_decorators;
    let __lbaBE_initializers = [];
    let __lbaBE_extraInitializers = [];
    let _dataLength_decorators;
    let _dataLength_initializers = [];
    let _dataLength_extraInitializers = [];
    let _dataLengthBE_decorators;
    let _dataLengthBE_initializers = [];
    let _dataLengthBE_extraInitializers = [];
    let _date_decorators;
    let _date_initializers = [];
    let _date_extraInitializers = [];
    let _fileFlags_decorators;
    let _fileFlags_initializers = [];
    let _fileFlags_extraInitializers = [];
    let _fileUnitSize_decorators;
    let _fileUnitSize_initializers = [];
    let _fileUnitSize_extraInitializers = [];
    let _interleaveGapSize_decorators;
    let _interleaveGapSize_initializers = [];
    let _interleaveGapSize_extraInitializers = [];
    let _volumeSequenceNumber_decorators;
    let _volumeSequenceNumber_initializers = [];
    let _volumeSequenceNumber_extraInitializers = [];
    let _volumeSequenceNumberBE_decorators;
    let _volumeSequenceNumberBE_initializers = [];
    let _volumeSequenceNumberBE_extraInitializers = [];
    let _identifierLength_decorators;
    let _identifierLength_initializers = [];
    let _identifierLength_extraInitializers = [];
    let __identifier_decorators;
    let __identifier_initializers = [];
    let __identifier_extraInitializers = [];
    var DirectoryRecord = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _length_decorators = [(_a = t).uint8.bind(_a)];
            _extendedAttributeRecordLength_decorators = [(_b = t).uint8.bind(_b)];
            __lba_decorators = [(_c = t).uint32.bind(_c)];
            __lbaBE_decorators = [(_d = t).uint32.bind(_d)];
            _dataLength_decorators = [(_e = t).uint32.bind(_e)];
            _dataLengthBE_decorators = [(_f = t).uint32.bind(_f)];
            _date_decorators = [member(ShortFormDate)];
            _fileFlags_decorators = [(_g = t).uint8.bind(_g)];
            _fileUnitSize_decorators = [(_h = t).uint8.bind(_h)];
            _interleaveGapSize_decorators = [(_j = t).uint8.bind(_j)];
            _volumeSequenceNumber_decorators = [(_k = t).uint16.bind(_k)];
            _volumeSequenceNumberBE_decorators = [(_l = t).uint16.bind(_l)];
            _identifierLength_decorators = [(_m = t).uint8.bind(_m)];
            __identifier_decorators = [t.char(0)];
            __esDecorate(null, null, _length_decorators, { kind: "field", name: "length", static: false, private: false, access: { has: obj => "length" in obj, get: obj => obj.length, set: (obj, value) => { obj.length = value; } }, metadata: _metadata }, _length_initializers, _length_extraInitializers);
            __esDecorate(null, null, _extendedAttributeRecordLength_decorators, { kind: "field", name: "extendedAttributeRecordLength", static: false, private: false, access: { has: obj => "extendedAttributeRecordLength" in obj, get: obj => obj.extendedAttributeRecordLength, set: (obj, value) => { obj.extendedAttributeRecordLength = value; } }, metadata: _metadata }, _extendedAttributeRecordLength_initializers, _extendedAttributeRecordLength_extraInitializers);
            __esDecorate(null, null, __lba_decorators, { kind: "field", name: "_lba", static: false, private: false, access: { has: obj => "_lba" in obj, get: obj => obj._lba, set: (obj, value) => { obj._lba = value; } }, metadata: _metadata }, __lba_initializers, __lba_extraInitializers);
            __esDecorate(null, null, __lbaBE_decorators, { kind: "field", name: "_lbaBE", static: false, private: false, access: { has: obj => "_lbaBE" in obj, get: obj => obj._lbaBE, set: (obj, value) => { obj._lbaBE = value; } }, metadata: _metadata }, __lbaBE_initializers, __lbaBE_extraInitializers);
            __esDecorate(null, null, _dataLength_decorators, { kind: "field", name: "dataLength", static: false, private: false, access: { has: obj => "dataLength" in obj, get: obj => obj.dataLength, set: (obj, value) => { obj.dataLength = value; } }, metadata: _metadata }, _dataLength_initializers, _dataLength_extraInitializers);
            __esDecorate(null, null, _dataLengthBE_decorators, { kind: "field", name: "dataLengthBE", static: false, private: false, access: { has: obj => "dataLengthBE" in obj, get: obj => obj.dataLengthBE, set: (obj, value) => { obj.dataLengthBE = value; } }, metadata: _metadata }, _dataLengthBE_initializers, _dataLengthBE_extraInitializers);
            __esDecorate(null, null, _date_decorators, { kind: "field", name: "date", static: false, private: false, access: { has: obj => "date" in obj, get: obj => obj.date, set: (obj, value) => { obj.date = value; } }, metadata: _metadata }, _date_initializers, _date_extraInitializers);
            __esDecorate(null, null, _fileFlags_decorators, { kind: "field", name: "fileFlags", static: false, private: false, access: { has: obj => "fileFlags" in obj, get: obj => obj.fileFlags, set: (obj, value) => { obj.fileFlags = value; } }, metadata: _metadata }, _fileFlags_initializers, _fileFlags_extraInitializers);
            __esDecorate(null, null, _fileUnitSize_decorators, { kind: "field", name: "fileUnitSize", static: false, private: false, access: { has: obj => "fileUnitSize" in obj, get: obj => obj.fileUnitSize, set: (obj, value) => { obj.fileUnitSize = value; } }, metadata: _metadata }, _fileUnitSize_initializers, _fileUnitSize_extraInitializers);
            __esDecorate(null, null, _interleaveGapSize_decorators, { kind: "field", name: "interleaveGapSize", static: false, private: false, access: { has: obj => "interleaveGapSize" in obj, get: obj => obj.interleaveGapSize, set: (obj, value) => { obj.interleaveGapSize = value; } }, metadata: _metadata }, _interleaveGapSize_initializers, _interleaveGapSize_extraInitializers);
            __esDecorate(null, null, _volumeSequenceNumber_decorators, { kind: "field", name: "volumeSequenceNumber", static: false, private: false, access: { has: obj => "volumeSequenceNumber" in obj, get: obj => obj.volumeSequenceNumber, set: (obj, value) => { obj.volumeSequenceNumber = value; } }, metadata: _metadata }, _volumeSequenceNumber_initializers, _volumeSequenceNumber_extraInitializers);
            __esDecorate(null, null, _volumeSequenceNumberBE_decorators, { kind: "field", name: "volumeSequenceNumberBE", static: false, private: false, access: { has: obj => "volumeSequenceNumberBE" in obj, get: obj => obj.volumeSequenceNumberBE, set: (obj, value) => { obj.volumeSequenceNumberBE = value; } }, metadata: _metadata }, _volumeSequenceNumberBE_initializers, _volumeSequenceNumberBE_extraInitializers);
            __esDecorate(null, null, _identifierLength_decorators, { kind: "field", name: "identifierLength", static: false, private: false, access: { has: obj => "identifierLength" in obj, get: obj => obj.identifierLength, set: (obj, value) => { obj.identifierLength = value; } }, metadata: _metadata }, _identifierLength_initializers, _identifierLength_extraInitializers);
            __esDecorate(null, null, __identifier_decorators, { kind: "field", name: "_identifier", static: false, private: false, access: { has: obj => "_identifier" in obj, get: obj => obj._identifier, set: (obj, value) => { obj._identifier = value; } }, metadata: _metadata }, __identifier_initializers, __identifier_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            DirectoryRecord = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        data;
        _rockRidgeOffset;
        _view;
        _suEntries;
        _file;
        _dir;
        /**
         * @internal
         */
        _kind;
        constructor(data, 
        /**
         * Offset at which system use entries begin. Set to -1 if not enabled.
         */
        _rockRidgeOffset) {
            this.data = data;
            this._rockRidgeOffset = _rockRidgeOffset;
            deserialize(this, data);
            this._view = new DataView(data.buffer);
        }
        get hasRockRidge() {
            return this._rockRidgeOffset > -1;
        }
        get rockRidgeOffset() {
            return this._rockRidgeOffset;
        }
        /**
         * !!ONLY VALID ON ROOT NODE!!
         * Checks if Rock Ridge is enabled, and sets the offset.
         */
        rootCheckForRockRidge(isoData) {
            const dir = this.getDirectory(isoData);
            this._rockRidgeOffset = dir.getDotEntry(isoData)._getRockRidgeOffset(isoData);
            if (this._rockRidgeOffset > -1) {
                // Wipe out directory. Start over with RR knowledge.
                this._dir = undefined;
            }
        }
        length = __runInitializers(this, _length_initializers, void 0);
        extendedAttributeRecordLength = (__runInitializers(this, _length_extraInitializers), __runInitializers(this, _extendedAttributeRecordLength_initializers, void 0));
        _lba = (__runInitializers(this, _extendedAttributeRecordLength_extraInitializers), __runInitializers(this, __lba_initializers, void 0));
        _lbaBE = (__runInitializers(this, __lba_extraInitializers), __runInitializers(this, __lbaBE_initializers, void 0));
        get lba() {
            return this._lba * 2048;
        }
        set lba(value) {
            if (!Number.isInteger(value / 2048)) {
                throw new ErrnoError(Errno.EINVAL, 'Invalid LBA value');
            }
            this._lba = value / 2048;
        }
        dataLength = (__runInitializers(this, __lbaBE_extraInitializers), __runInitializers(this, _dataLength_initializers, void 0));
        dataLengthBE = (__runInitializers(this, _dataLength_extraInitializers), __runInitializers(this, _dataLengthBE_initializers, void 0));
        date = (__runInitializers(this, _dataLengthBE_extraInitializers), __runInitializers(this, _date_initializers, new ShortFormDate()));
        get recordingDate() {
            return this.date.date;
        }
        fileFlags = (__runInitializers(this, _date_extraInitializers), __runInitializers(this, _fileFlags_initializers, void 0));
        fileUnitSize = (__runInitializers(this, _fileFlags_extraInitializers), __runInitializers(this, _fileUnitSize_initializers, void 0));
        interleaveGapSize = (__runInitializers(this, _fileUnitSize_extraInitializers), __runInitializers(this, _interleaveGapSize_initializers, void 0));
        volumeSequenceNumber = (__runInitializers(this, _interleaveGapSize_extraInitializers), __runInitializers(this, _volumeSequenceNumber_initializers, void 0));
        volumeSequenceNumberBE = (__runInitializers(this, _volumeSequenceNumber_extraInitializers), __runInitializers(this, _volumeSequenceNumberBE_initializers, void 0));
        identifierLength = (__runInitializers(this, _volumeSequenceNumberBE_extraInitializers), __runInitializers(this, _identifierLength_initializers, void 0));
        /**
         * Variable length, which is not supported by Utilium at the moment
         */
        _identifier = (__runInitializers(this, _identifierLength_extraInitializers), __runInitializers(this, __identifier_initializers, ''));
        get identifier() {
            const stringData = this.data.slice(33, 33 + this.identifierLength);
            return this._decode(stringData);
        }
        fileName(isoData) {
            if (this.hasRockRidge) {
                const fn = this._rockRidgeFilename(isoData);
                if (fn != null) {
                    return fn;
                }
            }
            const ident = this.identifier;
            if (this.isDirectory(isoData)) {
                return ident;
            }
            // Files:
            // - MUST have 0x2E (.) separating the name from the extension
            // - MUST have 0x3B (;) separating the file name and extension from the version
            // Gets expanded to two-byte char in Unicode directory records.
            const versionSeparator = ident.indexOf(';');
            if (versionSeparator === -1) {
                // Some Joliet filenames lack the version separator, despite the standard specifying that it should be there.
                return ident;
            }
            if (ident[versionSeparator - 1] === '.') {
                // Empty extension. Do not include '.' in the filename.
                return ident.slice(0, versionSeparator - 1);
            }
            // Include up to version separator.
            return ident.slice(0, versionSeparator);
        }
        isDirectory(isoData) {
            let rv = !!(this.fileFlags & 2 /* FileFlags.Directory */);
            // If it lacks the Directory flag, it may still be a directory if we've exceeded the directory
            // depth limit. Rock Ridge marks these as files and adds a special attribute.
            if (!rv && this.hasRockRidge) {
                rv = this.getSUEntries(isoData).filter(e => e instanceof CLEntry).length > 0;
            }
            return rv;
        }
        isSymlink(isoData) {
            return this.hasRockRidge && this.getSUEntries(isoData).filter(e => e instanceof SLEntry).length > 0;
        }
        getSymlinkPath(isoData) {
            let p = '';
            const entries = this.getSUEntries(isoData);
            for (const entry of entries) {
                if (entry instanceof SLEntry) {
                    const components = entry.componentRecords;
                    for (const component of components) {
                        const flags = component.flags;
                        if (flags & 2 /* SLComponentFlags.CURRENT */) {
                            p += './';
                        }
                        else if (flags & 4 /* SLComponentFlags.PARENT */) {
                            p += '@zenfs/core/';
                        }
                        else if (flags & 8 /* SLComponentFlags.ROOT */) {
                            p += '/';
                        }
                        else {
                            p += component.content(this._decode);
                            if (!(flags & 1 /* SLComponentFlags.CONTINUE */)) {
                                p += '/';
                            }
                        }
                    }
                    if (!entry.continueFlag) {
                        // We are done with this link.
                        break;
                    }
                }
            }
            if (p.length > 1 && p[p.length - 1] === '/') {
                // Trim trailing '/'.
                return p.slice(0, p.length - 1);
            }
            else {
                return p;
            }
        }
        getFile(isoData) {
            if (this.isDirectory(isoData)) {
                throw new Error('Tried to get a File from a directory.');
            }
            this._file ||= isoData.slice(this.lba, this.lba + this.dataLength);
            return this._file;
        }
        getDirectory(isoData) {
            if (!this.isDirectory(isoData)) {
                throw new Error('Tried to get a Directory from a file.');
            }
            this._dir ||= this._constructDirectory(isoData);
            return this._dir;
        }
        getSUEntries(isoData) {
            if (!this._suEntries) {
                this._constructSUEntries(isoData);
            }
            return this._suEntries;
        }
        getString() {
            return this._decode(this.data);
        }
        _decoder = __runInitializers(this, __identifier_extraInitializers);
        get _decode() {
            this._decoder ||= new TextDecoder(this._kind == 'Joliet' ? 'utf-16be' : 'utf-8');
            return (data) => this._decoder.decode(data).toLowerCase();
        }
        _constructDirectory(isoData) {
            return new Directory(this, isoData);
        }
        _rockRidgeFilename(isoData) {
            const nmEntries = this.getSUEntries(isoData).filter(e => e instanceof NMEntry);
            if (nmEntries.length === 0 || nmEntries[0].flags & (2 /* NMFlags.CURRENT */ | 4 /* NMFlags.PARENT */)) {
                return null;
            }
            let str = '';
            for (const e of nmEntries) {
                str += e.name(this._decode);
                if (!(e.flags & 1 /* NMFlags.CONTINUE */)) {
                    break;
                }
            }
            return str;
        }
        _constructSUEntries(isoData) {
            let i = 33 + this.data[32];
            if (i % 2 === 1) {
                // Skip padding field.
                i++;
            }
            i += this._rockRidgeOffset;
            this._suEntries = constructSystemUseEntries(this.data, i, BigInt(this.length), isoData);
        }
        /**
         * !!ONLY VALID ON FIRST ENTRY OF ROOT DIRECTORY!!
         * Returns -1 if rock ridge is not enabled. Otherwise, returns the offset
         * at which system use fields begin.
         */
        _getRockRidgeOffset(isoData) {
            // In the worst case, we get some garbage SU entries.
            // Fudge offset to 0 before proceeding.
            this._rockRidgeOffset = 0;
            const suEntries = this.getSUEntries(isoData);
            if (suEntries.length > 0) {
                const spEntry = suEntries[0];
                if (spEntry instanceof SPEntry && spEntry.checkMagic()) {
                    // SUSP is in use.
                    for (let i = 1; i < suEntries.length; i++) {
                        const entry = suEntries[i];
                        if (entry instanceof RREntry || (entry instanceof EREntry && entry.extensionIdentifier === rockRidgeIdentifier)) {
                            // Rock Ridge is in use!
                            return spEntry.skip;
                        }
                    }
                }
            }
            // Failed.
            this._rockRidgeOffset = -1;
            return -1;
        }
    };
    return DirectoryRecord = _classThis;
})();
export { DirectoryRecord };
//# sourceMappingURL=DirectoryRecord.js.map